import { render, staticRenderFns } from "./addHotelProductDialog.vue?vue&type=template&id=2de40ce8&scoped=true"
import script from "./addHotelProductDialog.vue?vue&type=script&lang=js"
export * from "./addHotelProductDialog.vue?vue&type=script&lang=js"
import style0 from "./addHotelProductDialog.vue?vue&type=style&index=0&id=2de40ce8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de40ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de40ce8')) {
      api.createRecord('2de40ce8', component.options)
    } else {
      api.reload('2de40ce8', component.options)
    }
    module.hot.accept("./addHotelProductDialog.vue?vue&type=template&id=2de40ce8&scoped=true", function () {
      api.rerender('2de40ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/addHotelProductDialog.vue"
export default component.exports